angular.module('unergie.main')
.controller('sgeCtrl', ($scope, $stateParams, ApiUser, AlertManager, ErrorCatcher, NgTableParams, BoFeaturesService) => {
    $scope.accessSge = BoFeaturesService.isFeatureOn('accessSge')
    $scope.accessHistoReadings = BoFeaturesService.isFeatureOn('accessHistoReadings')

    $scope.id_contract = $stateParams.search
    $scope.id_prm = undefined
    $scope.isC5 = false

    const getPrm = function (idContract) {
        if (!idContract) {
            const payload = { id_prm: $scope.id_prm }
            payload.consent = $scope.consent || 'NONE'
            return ApiUser.fetchPRMDetails(payload).$promise
        }
        return ApiUser.fetchPrmDetailsForContract({ idContract }).$promise
    }

    const getCons = function (idContract) {
        if (!idContract) {
            return ApiUser.rawCons({
                id_prm: $scope.id_prm,
                consent: $scope.consent || undefined,
            }).$promise
        }

        return ApiUser.rawConsForContract({ idContract, consent: $scope.consent || undefined }).$promise
    }


    const fetchPRM = function (idContract) {
        $scope.fetchingPRM = true
        $scope.prmDetails = undefined
        $scope.tableCases = undefined
        $scope.transformCourant = undefined
        $scope.longueursLiaisons = undefined
        return getPrm(idContract).then((details) => {
            if (details) {
                const jsonPrm = details.toJSON()
                $scope.prmDetails = _.get(jsonPrm, 'result.point', undefined)
                if ($scope.prmDetails) {
                    $scope.isC5 = _.get($scope.prmDetails, 'donneesGenerales.segment.libelle', 'C5') === 'C5'
                    $scope.transformCourant = $scope.prmDetails.situationComptage.dispositifComptage.transformateurCourant
                    $scope.longueursLiaisons = $scope.prmDetails.situationAlimentation.alimentationPrincipale.longueursLiaisons
                }
            }

            $scope.clientContactWindow = $scope.prmDetails.situationComptage.dispositifComptage.compteurs.compteur.parametresTeleAcces
                ? $scope.prmDetails.situationComptage.dispositifComptage.compteurs.compteur.parametresTeleAcces.fenetreEcouteClient
                : null
            $scope.id_prm = _.get($scope, 'prmDetails.attributes.id', undefined)

            const classeTemporelle = _.get($scope, 'prmDetails.derniersIndexReleves.grilleFrn.classesTemporelles.classeTemporelle', undefined)
            if (classeTemporelle && !angular.isArray(classeTemporelle)) {
                $scope.prmDetails.derniersIndexReleves.grilleFrn.classesTemporelles.classeTemporelle = [classeTemporelle]
            }

            const grilleFrn = _.get($scope, 'prmDetails.derniersIndexPublies.grilleFrn.classesTemporelles.classeTemporelle', undefined)
            if (grilleFrn && !angular.isArray(grilleFrn)) {
                $scope.prmDetails.derniersIndexPublies.grilleFrn.classesTemporelles.classeTemporelle = [grilleFrn]
            }

            let affaires = _.get($scope, 'prmDetails.historiqueAffaires.affaire', undefined)
            if (affaires && !angular.isArray(affaires)) {
                affaires = [affaires]
            }
            $scope.tableCases = new NgTableParams({ sorting: { dateEnvoi: 'desc' } }, { dataset: affaires })
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.fetchingPRM = false
        })
    }

    const fetchHistoReadings = function (idContract) {
        $scope.fetchingHistoReadings = true
        $scope.prmCons = undefined
        $scope.histoReadingsError = null
        return getCons(idContract)
        .then((cons) => {
            if (cons) {
                const jsonCons = cons.toJSON()
                $scope.prmCons = _.get(jsonCons, 'result.seriesMesuresDateesGrilleFrn.serie', undefined)
            }
            if ($scope.prmCons) {
                let consData = []
                _.forEach($scope.prmCons, (tempClass) => {
                    consData = consData.concat(_.map(_.get(tempClass, 'mesuresDatees.mesure', undefined), (mesure) => {
                        mesure.tempClass = tempClass.classeTemporelle.attributes.code
                        mesure.unite = tempClass.unite
                        return mesure
                    }))
                })
                if (consData.length > 0) {
                    $scope.tableCons = new NgTableParams({ sorting: { dateDebut: 'desc' } }, { dataset: consData })
                }
            }
        })
        .catch((error) => {
            console.log(`Error while fetching consumptions`, error)
            $scope.histoReadingsError = idContract ?
                `L'état du point ne permet pas la consultation des données de mesures sur le point.` :
                `Le type de consentement ne permet pas la consultation des données de mesures sur le point.`
        })
        .finally(() => {
            $scope.fetchingHistoReadings = false
        })
    }

    $scope.fetchPrmInfos = function (idContract) {
        fetchPRM(idContract)
        return fetchHistoReadings(idContract)
    }

    if ($scope.id_contract) {
        $scope.fetchPrmInfos($scope.id_contract)
    }

    $scope.formatEnedisDate = (date) => (date ? moment(date, 'YYYY-MM-DDZ').format('DD/MM/YYYY') : 'N/A')
})
